"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=facts.js.map